module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue3.d3eb09ff.jpg";